module.exports = __webpack_public_path__ + "img/VU.07e0b5ab.png";